<template>
  <div class="content">
    <transition name="fade">
      <Konami :konami="selection.konami" v-if="code" key="konami"></Konami>
      <CmpRenderer :components="selection.content" v-else key="content"></CmpRenderer>
    </transition>
  </div>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { SelectionComponent } from 'src/modules/prismic/components/SelectionComponent'
import Konami from '../components/utils/Konami'
import config from 'config'

export default {
  name: 'Selection',
  mixins: [SelectionComponent],
  components: {
    Konami
  },
  asyncData({ context }) {
    return new Promise((resolve, reject) => {
      if (context) context.output.cacheTags.add(`selection`)
      return resolve()
    })
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url
    },
    clientUrl() {
      return config.client.url
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

// Fade
.fade-enter,
.fade-leave-to {
  left: 0;
  right: 0;
}
</style>
